module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00007-fs8.cc5e01d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00007-fs8.png
// module id = 161
// module chunks = 0